module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.loading) ? _c('pl-spinner') : _c('div', {
    staticClass: "justify-center"
  }, [_c('div', {
    staticClass: "bg-gray-50 w-full p-3 mb-5 text-gray-400"
  }, [(_vm.getProfile.role === 'teacher') ? _c('span', [_vm._v("\n        You can connect your Parlay account to your account from other\n        Learning Management Systems at the school / district.\n      ")]) : _c('span', [_vm._v("\n        You can connect your Parlay account to your account from other\n        Learning Management Systems that your school or teacher uses in your\n        classroom.\n      ")])]), _vm._v(" "), _c('div', [_c('profile-integration-card', {
    attrs: {
      "integration": _vm.classroom_integration,
      "title": _vm.google_classroom_title,
      "icon": _vm.google_classroom_icon,
      "code": _vm.google_classroom_code,
      "memberships": _vm.memberships
    }
  })], 1)]), _vm._v(" "), (_vm.google_classroom_modal) ? _c('google-classroom-modal', {
    attrs: {
      "courses": _vm.courses
    },
    on: {
      "close": function($event) {
        _vm.google_classroom_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_disconnect_classroom_modal) ? _c('disconnect-google-classroom-modal', {
    on: {
      "close": function($event) {
        _vm.show_disconnect_classroom_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_courses_to_import_modal) ? _c('courses-to-import-modal', {
    attrs: {
      "courses": _vm.courses_to_import,
      "integration": _vm.integration,
      "loadingCourses": _vm.loading_courses,
      "memberships": _vm.memberships
    },
    on: {
      "close": function($event) {
        _vm.show_courses_to_import_modal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-a6b6961c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/profile/profileTabs/integrationsTab.vue
// module id = 1633
// module chunks = 61